// Remove account components on mobile
if (matchMedia('(max-width: 749px)').matches) {
  document.querySelectorAll(
    'header-actions anchored-popover-component.account-popover,' +
    'header-actions anchored-drawer-component.account-drawer,' +
    'header-actions [aria-controls="account-drawer"],' +
    'header-actions a[href$="/account"]'
  ).forEach(el => el.remove());
}
